import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'

import { PageLayout } from 'components'
import ToastServices from 'libraries/toastify/toastServices'

import './i18n'
import './styles/index.global.scss'

const App = () => (
  <HelmetProvider>
    <BrowserRouter>
      <PageLayout />
      <ToastServices />
    </BrowserRouter>
  </HelmetProvider>
)

export default App
